export default __webpack_public_path__ + "static/media/closer-hunt.38340eb2.mp3";